import angular from 'angular';

import translationsModuleName from '../../../../../lib/translation';
import positionSearchServiceModule from '../../../../../lib/service/PositionSearchService';

import uiTypeaheadModuleName from 'angular-ui-bootstrap/src/typeahead'

// Component
import component from './positionSearchForm.component';

const moduleName = 'staff.dashboardScreen.positionSearchForm';
let module = angular.module(moduleName, [
  translationsModuleName,
  positionSearchServiceModule.name,
  uiTypeaheadModuleName,
]);

module.component('positionSearchForm', component);

export default module;
